import React from 'react'
import Heading from '../Components/Heading/Heading'

function Gallerie() {
    return (
        <div>
            <Heading>Gallerie</Heading>
        </div>
    )
}

export default Gallerie
